import { updatesData } from '@/mocks/homeData';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="section-container max-w-4xl">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            最新动态
          </h2>
          <p className="text-sm text-foreground-500 mt-1">平台更新 · 内容快讯</p>
        </div>

        <div className="relative">
          <div className="absolute left-[19px] top-2 bottom-2 w-px bg-background-200 hidden sm:block"></div>

          <div className="flex flex-col gap-4">
            {updatesData.map((update, index) => (
              <div key={index} className="flex gap-4 md:gap-6">
                <div className="hidden sm:flex flex-col items-center flex-shrink-0 pt-1">
                  <div className="w-[10px] h-[10px] rounded-full bg-primary-500 flex-shrink-0"></div>
                </div>
                <div className="flex-1 bg-background-100 rounded-xl border border-background-200 p-4 md:p-5">
                  <span className="text-xs text-foreground-400 mb-1 block">{update.date}</span>
                  <h3 className="text-sm md:text-base font-semibold text-foreground-950 mb-1">
                    {update.title}
                  </h3>
                  <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                    {update.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}